import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'app-modal-dokument-loeschen',
    templateUrl: './modal-dokument-loeschen.page.html'
})
export class ModalDokumentLoeschenPage implements OnInit {
    @Input() titel: string;

    private aiName = 'DokumentLoeschenModal';

    constructor(private modalCtrl: ModalController) {
    }

    ngOnInit() {
    }

    async ok() {
        await this.modalCtrl.dismiss('ok');
    }

    async abbrechen() {
        await this.modalCtrl.dismiss();
    }
}
